module.exports = __webpack_public_path__ + "media/img/use-ico-4-c6614eff1ceb2c367e88401f36199b46.svg";